export default {
  customer: {
    prev: "上一页",
    nextv: "下一页",
    noAuth: "您无权查看此视频",
    catchword: "信仰创新的力量",
    placeholderSearch: "关键字",
    pleaseLogin: "您好！请登录",
    level1: "项目类别：",
    home: "首页",
    reset: "重置",
    unit1: "人",
    unit2: "条",
    coursevalue: "课程价值",
    noData: "暂无数据",
    pleaseReview: "给该课程评分：",
    publish: "发表",
    reviewArea: "评论区",
    pubSuc: "发表成功",
    me: "我",
  },
  global: {
    allTestComp: "全部任务已完成啦",
    testEnd: "任务已结束",
    test: "任务未开始",
    view: "人观看",
    identity1: "内部员工",
    identity2: "战略客户",
    pleaseChoose: "选择登录身份",
    docTitle1: "itc商学院",
    docTitle2: "知之会议录播平台",
    forget: "忘记密码？",
    warningTitle: "版权声明",
    warning:
      "本课程版权归广东保伦电子股份有限公司所有，仅限个人学习，严禁任何形式的录制、传播和账号分享。一经发现，公司将依法保留追究权，情节严重者将承担法律责任。",
    sectionNum: "第{num}节",
    sort1: "一级分类",
    sort2: "二级分类",
    pleaseSignIn: "请登录",
    image: "图片",
    search: "搜索",
    choose: "请选择",
    searchKeyword: "请输入关键词查询",
    sure: "确 定",
    save: "保存",
    submit: "提交",
    cancel: "取 消",
    noData: "暂无数据",
    noDataTable: "暂无更新，敬请期待",
    play: "播放",
    noCate: "暂无分类",
    noPoster: "暂无封面",
    top: "置顶",
    download: "下载",
    downCount: "下载量",
    allowDown: "允许下载",
    allowShare: "允许分享",
    resourceCate: "资料分类",
    back: "返回",
    yes: "是",
    no: "否",
    all: "全部",
    allCate: "全部分类",
    defaultSort: "默认分类",
    uploadTime: "上传时间",
    keepTime: "保存时间",
    size: "大小",
    score: "评分",
    check: "查看",
    copy: "复 制",
    copySuccess: "复制成功",
    type: "类型",
    collect0: "已取消收藏",
    collect1: "收藏成功",
    tips: "提示",
    keyword: "关键字",
    nokeyword: "暂无关键字",
    forever: "永久保存",
    halfYear: "半年",
    oneYear: "一年",
    month: "个月",
    loading: "加载中",
    selectDate: "选择日期",
    authorityMessage: "暂无观看权限，请联系管理员开通",
    authorityMessage1: "当前视频限制观看权限，请登录后查看",
    copyUrlmessage: "复制链接发送用户，即可通过网页或H5查看分享内容",
    webUrl: "网页端",
    H5Url: "移动端",
    linkUrl: "链接",
    successfullyScored: "评分成功",
    notAllowedShare: "该资源不允许分享",
    complete: "完成",
  },
  form: {
    web: "官网",
    changePass: "重设密码",
    certify: "身份确认",
    certifySuc: "认证成功",
    getCodeSuc: "验证码已发送",
    reGetCode: "重新获取",
    getCode: "获取验证码",
    phoneNumErr: "手机号码错误",
    phoneNumber: "手机号",
    position: "职位",
    email: "邮箱",
    email1: "请输入邮箱地址",
    companyName: "公司名称",
    emailEmpty: "邮箱不能为空",
    rightEmail: "请输入正确的邮箱",
    phone: "手机",
    phone1: "请输入手机号",
    phone2: "请输入手机号码",
    rightPhone: "请输入正确的手机号",
    pleaseInput: "请输入您的问题内容",
    typeEmpty: "请选择问题类型",
    codeEmpty: "请输入验证码",
    codeError: "请输入正确的验证码",
    maxl20: "最多可以输入20个字符",
    submiting: "正在保存中，请勿刷新浏览器",
    resEmpty: "请填写资料名称",
    chooseFile: "请上传文件",
    addr: "地址",
    number: "联系电话",
  },
  response: {
    timeOut: "请求超时",
  },
  modules: {
    live: "在线直播",
    video: "视频点播",
    settings: "账号设置",
  },
  rules: {
    enterAcc: "请输入账号",
    account: "账号由4~16位英文、数字、下划线组成",
    pwd: "密码由6~16位英文、数字、下划线组成",
    strongPwd:
      "密码限制8~16，由数字、大写字母、小写字母，特殊符号3种或3种以上组合组成",
    spaceKey: "请勿输入空格",
    trim: "内容前后不可有空格",
    leftTrim: "内容前面不可有空格",
    rightTrim: "内容后面不可有空格",
    mobile: "电话格式不正确",
    ip: "请输入正确的ip地址",
    port: "请输入正确的端口",
    mask: "请输入正确的子网掩码",
    chinese: "请勿输入特殊字符",
    link: "链接格式错误",
  },
  upload: {
    pic: "上传图片",
    success: "上传成功",
    fail: "上传失败",
    error: "上传出错",
    uploading: "正在上传，请稍等...",
    paused: "暂停",
    waiting: "等待上传",
    imgType: "只允许上传图片格式的文件",
    score2M: "只允许上传2M以内的文件",
  },
  homepage: {
    special_tcamp: "专项训练营",
    product_focus: "新上好课",
    nice_video: "精品推荐",
    Visitors: "游客无权进入",
    noOpen: "此功能暂未开放",
    needLogin: "此功能需登录后才能使用",
    pleaseLogin: "你好,请登录",
    loginFirst: "请先登录",
    register: "注册",
    changeRole: "切换身份",
    manage: "管理中心",
    settings: "账号设置",
    loginOut: "安全退出",
    newRes: "最新资料",
    more: "更多",
    studyTest: "学习任务",
    moreVideo: "更多视频",
    hotVideo: "热门视频",
    aboutUs: "关于我们",
    news: "新闻公告",
    annex: "附件",
    latest: "最新资讯",
    like0: "未点赞",
    like1: "已点赞",
    newsDetail: "资讯详情",
    operation: "操作手册",
    question: "常见问题",
    user: "用户反馈",
    write: "填写反馈",
    feedback: "问题反馈",
    tips1: "请在下方填写您在使用过程中遇到的问题，我们将仔细阅读您的反馈！",
    tips2:
      "请尽可能详细地描述您遇到的问题，您的反馈将是我们提升平台质量的最好保证",
    identify: "看不清，再换一张",
    questionType: "问题类型",
    selectQues: "请选择问题类型",
    yourEmail: "你的邮箱",
    msgEasy: "方便我们更快地联系到你",
    code: "验证码",
    string4: "输入右侧四位字符",
    resource: "资料",
    album: "专辑",
    time: "时间",
    uploadResource: "上传我的资料",
    resource_cate: "分类",
    ranking: "下载排行",
    uploadRes: "上传资料",
    downloadRes: "资料下载",
    chooseRes: "选择资料",
    resTypes: "支持常用文档，图片，音频，压缩文件等格式",
    resName: "资料名称",
    Moderated: "请等待管理员审核",
    shareLink: "分享链接",
    transcoding: "正在转码中，稍等片刻刷新页面观看",
    deleted: "当前资料已被删除",
    onlyDown: "此资料仅供下载，不支持预览",
    canotDown: "该资料创建者不允许下载",
    course: "课程",
    learner: "学习人数",
    catalog: "专辑目录",
    introduction: "专辑介绍",
    video: "视频",
    videoDeleted: "视频已被删除",
    test: "考题",
    chapter: "第1章",
    playCounts: "总播放量",
    popularity: "人气",
    heat: "热度",
    testDetail: "试卷详情",
    fullMarks: "满分",
    marks: "分",
    difficulty: "难度",
    answer: "答案",
    statistics: "统计",
    result1: "共2题，1分",
    result2: "本题共被作答2次，正确率为1%",
    analysis: "解析",
    closeAnalysis: "关闭解析",
    checkAnalysis: "查看解析",
    downTest: "下载试卷",
    template: "模板",
    A4: "A4纸竖排",
    A3: "A3纸竖排",
    answerType1: "试题后面紧跟答案",
    answerType2: "试题和解析分离",
    answerType3: "只下载试卷",
    answerType4: "只下载答案",
    videoCate: "视频分类",
    videoIntr: "视频简介",
    testStatus: "已完成",
    hasComplete: "待完成",
    videoNotice: "课程价值",
    classIntr: "课程介绍",
    teacherIntr: "讲师介绍",
    comment: "评分评论",
    score: "给该课程评分",
    plaComment: "快来点评一下吧，大胆想说出你的想法~",
    yes: "确定",
    comments: "评论",
    teacherInfo: "讲师信息",
    otherClass: "其他课程",
    watched: "观看过的人",
    enterLive: "进入直播间",
    forbitted: "你已被限制观看",
    checkArea: "查看限制范围",
    noAllow: "不能查看的范围",
    inputPsw: "输入直播密码",
    pswSetted: "该直播设置了观看密码，需要输入密码才能观看哦",
    getPsw: "请联系主讲人：{speaker} 获取密码",
    living: "直播中",
    notStart: "未开始",
    liveOver: "直播已结束",
    liveNeedLogin: "该直播需要登录才能观看",
    liveName: "直播名称",
    liveTime: "直播时间",
    onlineCounts: "在线人数",
    liveIntr: "直播简介",
    barrageOpen: "弹幕已开启",
    barrageOff: "弹幕已关闭",
    connect: "网络异常，请检查网络",
    discuss: "讨论区",

    yourWord: "写下你想说的话",
    member: "成员",
    shareAddr: "分享地址",
    forbit: "你已经被禁言了",
    forbit2: "该词已禁用，请重新输入讨论内容",

    grading: "给该课程评分",
    profileHolder: "快来点评一下吧，大胆想说出你的想法~",
    cutImage: "截图",
    edit: "编辑",
    delete: "删除",
    commontCutImage: "评论截图",
    addComments: "请输入评论内容",
    delCommentsWhat: "确定要删除此评论吗",
    delSuccess: "删除成功",
    notDel: "已取消删除",
  },
  register: {
    relogin: "重新登录？",
    gologin: "返回登录",
    login: "登录",
    account: "账号",
    hasAccount: "已经有账号？",
    hasAccount2: "已有账号？",
    back: "返回登录",
    username: "用户名",
    namePl: "请填写真实姓名",
    nameEmpty: "真实姓名不能为空",
    gender: "性别",
    genderEmpty: "性别不能为空",
    male: "男",
    female: "女",
    department: "部门",
    inputDepartment: "请选择所属部门",
    accountEmpty: "账号不能为空",
    psw: "密码",
    psw1: "请输入密码",
    newPsw: "请输入新密码",
    nowPsw: "当前密码",
    imputOldPsw: "请输入旧密码",
    psw6: "请输入6位数密码",
    pswtip: "密码由6~16位英文、数字、下划线组成",
    strongPwd:
      "密码限制8~16，由数字、大写字母、小写字母，特殊符号3种或3种以上组合组成",
    spwdHolder: "密码8~16位，含数字、大小写字母，特殊符号3种以上",
    psw16: "密码长度为6~16个字符哦",
    pswEmpty: "密码不能为空",
    checkPsw: "确认密码",
    psw200: "密码修改成功",
    checkPswPl: "重复密码",
    checkTwice: "请再次输入密码",
    noSame: "两次输入密码不一致",
    rememberTip: "重要信息，用于登录，请谨记！",
    submit: "提交注册",
    confirmed: "确认无误，提交注册",

    noAccount: "没有账号？",
    signUpNow: "立即注册",
    loginPlease: "欢迎登录~",
    newPassword: "新密码",
    surePassword: "确认密码",
    changeSuccess: "修改成功，请重新登录",
  },
  settings: {
    title1: "基本信息",
    title2: "修改密码",
    avatar: "头像",
    loginAcc: "登录账户",
    relName: "请输入真实姓名",
    replace: "替换",
    intro: "个人简介",
    introTip: "将你独特的一面展示给大家吧",
  },
  cdkey: {
    systemOverdue0: "系统已过期",
    systemOverdue: "您的系统已过期",
    getRegistrationKey: "为了不影响您的使用，请联系相关业务员获取注册码",
    serialNumber: "系列号",
    placeholder1: "将获取的序列号粘贴到此处",
    RegistrationCode: "注册码",
    placeholder2: "将获取的激活码粘贴到此处",
    activation: "激活",
    partTime: "生效时间",
    partModel: "移动端激活模块",
    android: "安卓",
    OnActivation: "已激活",
    UnActivation: "未激活",
    message: "请输入注册码",
    activationSuccess: "激活成功",
    activationFail: "激活失败",
    InfiniteDays: "无限天",
  },
};
